<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/gallery']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'gallery_common_name' | translate"></nz-statistic>
    </a>
</nz-card>